import React, { Fragment } from 'react';

import proExclusiveDesktop from 'images/pro_exclusive_desktop.svg';
import proExclusiveMobile from 'images/pro_exclusive_mobile.svg';
import proExclusiveTablet from 'images/pro_exclusive_tablet.svg';

interface ProExclusiveLogoProps {
  _class?: string;
  mobileClass?: string;
  tabletClass?: string;
  desktopClass?: string;
}

const ProExclusiveLogo = ({
  _class,
  mobileClass,
  tabletClass,
  desktopClass,
}: ProExclusiveLogoProps) => {
  return (
    <Fragment>
      <img
        src={proExclusiveMobile}
        alt="Pro Exclusive Logo"
        className={`tw-block sm:tw-hidden ${_class} ${mobileClass}`}
      />
      <img
        src={proExclusiveTablet}
        alt="Pro Exclusive Logo"
        className={`tw-hidden sm:tw-block md:tw-hidden ${_class} ${tabletClass}`}
      />
      <img
        src={proExclusiveDesktop}
        alt="Pro Exclusive Logo"
        className={`tw-hidden md:tw-block ${_class} ${desktopClass}`}
      />
    </Fragment>
  );
};

export default ProExclusiveLogo;
